import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import IntegrationService from "../../services/IntegrationService";
import {
  integrationListRequest,
  integrationListSuccess,
  integrationListFail,
  integrationCreateRequest,
  integrationCreateSuccess,
  integrationCreateFail,
  integrationDetailsRequest,
  integrationDetailsSuccess,
  integrationDetailsFail,
  integrationUpdateRequest,
  integrationUpdateSuccess,
  integrationUpdateFail,
  integrationDeleteRequest,
  integrationDeleteSuccess,
  integrationDeleteFail,
  integrationSubtypesRequest,
  integrationSubtypesSuccess,
  integrationSubtypesFail,
} from "../slices/integrationSlice";

function* integrationListSaga(action) {
  try {
    const response = yield call(IntegrationService.list, action.payload);
    yield put(integrationListSuccess(response.data));
  } catch (error) {
    yield put(integrationListFail(error.response?.data || error.message));
  }
}

function* integrationCreateSaga(action) {
  try {
    const response = yield call(IntegrationService.create, action.payload);
    yield put(integrationCreateSuccess(response.data));
  } catch (error) {
    yield put(integrationCreateFail(error.response?.data || error.message));
  }
}

function* integrationDetailsSaga(action) {
  try {
    const response = yield call(IntegrationService.details, action.payload);
    yield put(integrationDetailsSuccess(response.data));
  } catch (error) {
    yield put(integrationDetailsFail(error.response?.data || error.message));
  }
}

function* integrationUpdateSaga(action) {
  try {
    const response = yield call(IntegrationService.update, action.payload);
    yield put(integrationUpdateSuccess(response.data));
  } catch (error) {
    yield put(integrationUpdateFail(error.response?.data || error.message));
  }
}

function* integrationDeleteSaga(action) {
  try {
    yield call(IntegrationService.delete, action.payload);
    yield put(integrationDeleteSuccess());
    // Refresh the list after deletion
    yield put(integrationListRequest({}));
  } catch (error) {
    yield put(integrationDeleteFail(error.response?.data || error.message));
  }
}

function* integrationSubtypesSaga(action) {
  try {
    const response = yield call(IntegrationService.getSubtypes, action.payload);
    yield put(
      integrationSubtypesSuccess({
        subtype: action.payload.subtype,
        // The API answers 200 with a null response when the integration is
        // not enabled: that is "none", not an error.
        data: response?.data?.response ?? null,
      })
    );
  } catch (error) {
    // An older API answers 404 for the same case: treat it the same way.
    if (error?.response?.status === 404) {
      yield put(
        integrationSubtypesSuccess({
          subtype: action.payload.subtype,
          data: null,
        })
      );
      return;
    }
    yield put(
      integrationSubtypesFail({
        subtype: action.payload.subtype,
        error: error.response?.data || error.message,
      })
    );
  }
}

export default function* IntegrationSaga() {
  yield takeLatest(integrationListRequest.type, integrationListSaga);
  yield takeEvery(integrationCreateRequest.type, integrationCreateSaga);
  yield takeLatest(integrationDetailsRequest.type, integrationDetailsSaga);
  yield takeEvery(integrationUpdateRequest.type, integrationUpdateSaga);
  yield takeEvery(integrationDeleteRequest.type, integrationDeleteSaga);
  yield takeLatest(integrationSubtypesRequest.type, integrationSubtypesSaga);
}
